import { RestrictionModel } from './restriction.model';
import { ValidityModel } from './validity.model';
import { PointOfSalesModel  } from './pointofsales.model';

export class MerchandizingRulesConfigModel {
    public restrictions: RestrictionModel;
    public validity: ValidityModel;
    public pointOfSales: PointOfSalesModel;
}